'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Modal, Row} from "react-bootstrap";
import Title from "../Title";
import {hover, primary, whites} from "@/styles/globalStyleVars";
import Button from "../Button";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import reactHtmlParser from "react-html-parser";
import Link from 'next/link'

import {usePathname} from "next/navigation";
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';
import axios from "axios";



const MyComponent = ({data}) => {
    const [show, setShow] = useState(false);
    const [popupId, setPopupId] = useState('');
    const location = usePathname();

    const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    const handleShow = (element) => {
        setShow(true)
        setPopupId(element)

        // console.log('element', element)
    }

    const [isSubmitting, setIsSubmitting] = useState(false);


    const {register, control, handleSubmit, formState: {errors, isSubmitSuccessful}, reset, watch} = useForm({
        mode: "all",
    })

    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });


    const onSubmit = async (e) => {
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append('name', e?.name);
            formData.append('email', e?.email);
            formData.append('phone', e?.phone);
            formData.append('message', e?.message);
            formData.append('position', e?.position);
            formData.append('file', e?.cv?.[0]);
            formData.append('form_id', 'career-form');

            const response = await axios.post('https://cms.shantaequity.net/api/post-req-data/form-submit', formData);
            if (response.status === 200) {
                success('Form submitted successfully')
                console.log(response);

                reset(); // Reset form fields
            } else {
                error('Failed to submit form. Please try again later.');
                console.log(response);

            }
        } catch (err) {
            error('Failed to submit form. Please try again later.');
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };
    const onError = (errors) => {
        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };


    // modal close based on url
    useEffect(() => {
        if (location?.search === '') {
            handleClose()
        }
    }, [location])

    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsSmallScreen(window.innerWidth < 991);
        };

        // Set initial screen size
        checkScreenSize();

        // Update screen size on resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    return (
        <StyledComponent className={'jobs pb-100'}>
            <Container>
                <Row>
                    <Col sm={12}>
                        {data && data?.length > 0 ?
                            <Title margin={'0 0 50px'} text={'Join our <span>Team</span>'} spancolor={primary}/>
                            :
                            <p className={"no-job"}>Thank you for your interest in working with us. <br/> We do not have any job openings at the moment</p>
                        }
                    </Col>
                    {
                        data && data?.length > 0 &&
                        data?.map((element, index) => {
                            return (
                                <Col md={isSmallScreen ? 6 : 4} key={index}>
                                    <div className={'jobs__list'} onClick={() => handleShow(element)}>
                                            <h4>{element?.data?.title}</h4>

                                            {reactHtmlParser(element?.data?.overview)}

                                            <div className={'arrow'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.581" height="14.582"
                                                     viewBox="0 0 14.581 14.582">
                                                    <g id="Group_21337" data-name="Group 21337"
                                                       transform="translate(-400.193 605.558) rotate(-135)">
                                                        <path id="Path_9568" data-name="Path 9568" d="M0,6,6,0l6,6"
                                                              transform="translate(140.904 714.277) rotate(180)"
                                                              fill="none" stroke="#fff" stroke-linecap="round"
                                                              stroke-linejoin="round" stroke-width="1"/>
                                                        <path id="Path_9569" data-name="Path 9569" d="M0,12V0"
                                                              transform="translate(134.904 702.277)" fill="none"
                                                              stroke="#fff" stroke-linecap="round"
                                                              stroke-linejoin="round" stroke-width="1"/>
                                                    </g>
                                                </svg>

                                            </div>
                                    </div>
                                </Col>

                            )
                        })
                    }

                </Row>
            </Container>

            <Modal className={'login-modal as-career-modal'} show={show} onHide={handleClose}>
                <Modal.Body>

                    <Container>
                        <Row>
                            <Col className={''}>
                                <div className="modal-top">
                                    <p>{popupId?.data?.title}</p>
                                    <div className="destroy-modal" onClick={handleClose}>
                                        <img src="/images/static/modal-close.svg" alt=""/>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        <Row>


                            <Col md={12} xl={5} className={'mobile-padding'}>
                                <div className="job-data">
                                    {
                                        typeof window !== 'undefined' && window.innerWidth > 1200 ?
                                            <SimpleBar autoHide={true} style={{maxHeight: 'calc(100vh - 100px)'}}>

                                                {reactHtmlParser(popupId?.data?.description)}
                                            </SimpleBar> :
                                            <>

                                                {reactHtmlParser(popupId?.data?.description)}
                                            </>


                                    }

                                </div>
                            </Col>

                            <Col xl={{span: 6, offset: 1}} md={12} className={'mobile-padding'}>
                                <div className="job-form">

                                    <Form className={'form'} onSubmit={handleSubmit(onSubmit, onError)}>

                                        <input name={'spam_protector'} type='hidden'/>
                                        <input name={'form_id'} value={'feedback-form'} type='hidden'/>
                                        <div className="form-group">
                                            <Form.Group controlId="formBasicEmail">

                                                <Form.Control
                                                    className={errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                    {...register("name", {
                                                        required: 'Enter your name',
                                                        pattern: {
                                                            value: /^[A-Za-z ]+$/,
                                                            message: 'Name must contain only letters',
                                                        },
                                                    })}
                                                    type="text"
                                                    placeholder="Name*"
                                                />
                                                {errors.name && <span className="error-message">{errors.name.message}</span>}

                                            </Form.Group>

                                        </div>
                                        <div className="form-group">
                                            <Form.Group controlId="formBasicEmail">

                                            <Form.Control
                                                    className={errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                    {...register("email", {
                                                        required: {
                                                            value: true,
                                                            message: 'Enter your email'
                                                        },
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: 'Enter a valid email address'
                                                        }
                                                    })}
                                                    type="email"
                                                    placeholder="Email*"/>
                                                {errors.email && <span className="error-message">{errors.email.message}</span>}

                                            </Form.Group>
                                        </div>
                                        <div className="form-group">
                                            <Form.Group controlId="formBasicPhone">

                                                <Form.Control
                                                    className={errors?.phone?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                    {...register("phone", {
                                                        required: {
                                                            value: true,
                                                            message: 'Enter your phone first'
                                                        },
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: 'Enter a valid phone number',
                                                        }
                                                    })}
                                                    type="text"
                                                    placeholder="Phone Number*"/>
                                                {errors.phone && <span className="error-message">{errors.phone.message}</span>}

                                            </Form.Group>
                                        </div>
                                        <div className="form-group">
                                            <Form.Group controlId="formBasicMessage">

                                                <Form.Control
                                                    className={errors?.position?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                    {...register("position", {
                                                        required: 'Enter your position',
                                                    })}
                                                    type="text"
                                                    placeholder="Preferred Position*"
                                                />
                                                {errors.position && <span className="error-message">{errors.position.message}</span>}
                                            </Form.Group>

                                            <Form.Group controlId="formBasicsMessage">

                                                <Form.Control
                                                              className={errors?.message?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                              {...register("message", {
                                                                  required: {
                                                                      // value:true,
                                                                      message: 'Enter your message'
                                                                  },

                                                              })}
                                                              as="textarea"
                                                              rows={1}
                                                              placeholder="Cover Letter"/>

                                            </Form.Group>
                                        </div>

                                        <div className={`button-group`}>
                                            <div className={'button-group__input'}>
                                                <input accept={"application/pdf"}  {...register('cv')} type="file"/>
                                            </div>

                                            <p>{watch('cv')?.[0]?.name}</p>

                                            <div className={'width-fit'} onClick={handleSubmit(onSubmit, onError)}>
                                                <Button src={'#'} background={'#978C21'} color={'#FFF'} hoverBackground={'#FFF'}
                                                        hovercolor={'#3C3C3B'} arrowhoverfilter={'brightness(0%)'}
                                                        text={'Submit'}/>
                                            </div>

                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>

            </Modal>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    height: unset;
    overflow: hidden;
    .col-md-4 {
        margin-bottom: 40px;
    }

    .jobs__list {
        padding: 40px;
        background-color: #3C3C3B;
        border-radius: 12px;
        min-height: 100%;
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .arrow{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: ${primary};
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            &:before {
                content: '';
                position: absolute;
                height: 0;
                width: 100%;
                left: 0;
                bottom: 0;
                border-radius: 50%;
                background-color: ${whites};
                transition: .4s ease;
                z-index: 1;
            }
            svg{
                transition: .4s ease;
                position: relative;
                z-index: 2;
            }

        }
        //a {
        //    position: absolute;
        //    inset: 0;
        //    z-index: 2;
        //    width: 100%;
        //    height: 100%;
        //}

        img {
            transition: all .3s ease;
        }

        h4 {
            color: ${whites};
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 35px;
        }

        ul {
            li {
                color: #C6C6C6;
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 2px;
            }

            margin-bottom: 70px;
        }

        h6 {
            height: 40px;
            width: 40px;
            background-color: ${hover};
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            position: absolute;
            bottom: 40px;
            cursor: pointer;
            overflow: hidden;

            &:before {
                content: '';
                position: absolute;
                height: 100%;
                width: 0%;
                left: 0;
                border-radius: 50%;
                background-color: ${whites};
                transition: .4s ease;
            }

            &:hover {
                &:before {
                    width: 100%;
                }

                //img {
                //    filter: invert(19%) sepia(8%) saturate(98%) hue-rotate(21deg) brightness(92%) contrast(83%);
                //}
            }
        }
        &:hover{
            .arrow{
                svg{
                    transform: rotate(45deg);
                    path{
                        stroke: ${hover};
                    }
                }
                &:before{
                    height: 100%;
                }
            }
        }
        div{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .no-job {
        font-size: 24px;
        line-height: 32px;

    }

    @media (max-width: 767px) {
        .title {
            margin-bottom: 40px;
        }

        .jobs__list {
            padding: 30px 20px;

            h4 {
                margin-bottom: 20px;
            }

            ul {
                margin-bottom: 90px;
            }
        }
    }
`;

export default MyComponent;
